var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModalclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-4417 191)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(4424 -184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "aabf409156b2bcde53225f3492dda1ba",
    d: "M20,2A18,18,0,1,0,38,20,18.053,18.053,0,0,0,20,2Zm6.66,22.14a1.782,1.782,0,0,1-2.52,2.52L20,22.52l-4.14,4.14a1.782,1.782,0,1,1-2.52-2.52L17.48,20l-4.14-4.14a1.782,1.782,0,1,1,2.52-2.52L20,17.48l4.14-4.14a1.782,1.782,0,1,1,2.52,2.52L22.52,20Z",
    transform: "translate(4415 -193)",
    fill: "#e50914"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalclose);
export default __webpack_public_path__ + "static/media/modalclose.e23a101aa272df5683e5f325da5e7706.svg";
export { ForwardRef as ReactComponent };